import { request } from './request.js'
import { publicGet } from './public-get'

export const getSystemImages = () => publicGet('system-images')
export const getSystemRights = () => publicGet('system-rights')
export const getSeometas = () => publicGet('seometas')
export const getNavbars = () => request.get('navbars')
export const getIndexCarousels = () => publicGet('index-carousels')
export const getIndexMarquees = () => publicGet('index-marquees')
export const getMainMoneyDayGet = () => request.get('calendars')
export const getAntifrouds = () => request.get('antifrouds')
export const getIndexBanners = () => request.get('index-banners')
export const getVideoreSources = () => request.get('video-resources')
export const getLoginPops = () => request.get('login-pops')
